import { Events } from './utils/Events';
import { FCM } from '@ionic-native/fcm/ngx';
import { Component } from '@angular/core';

import { NavController } from '@ionic/angular';
import { AuthenticationService } from './services/authentication.service';
import { Router } from '@angular/router';
import { RestCallsService } from './rest-calls.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  selectedPath = '';
  activeIndex = 0;
  public appPages = [
    {
      title: 'Dashboard',
      url: '/members/tabs/dashboard',
      icon: 'home',
      iconPath: 'assets/icon/dashboard.png'
    },
    {
      title: 'Customers',
      url: '/members/tabs/customers',
      icon: 'contacts'
      ,
      iconPath: 'assets/icon/customer.png'
    },
    {
      title: 'Quotations',
      url: '/members/tabs/quotations',
      icon: 'quote',
      iconPath: 'assets/icon/qutation.png'
    },
    {
      title: 'Performa Invoice',
      url: '/members/tabs/performaInvoice',
      icon: 'checkmark',
      iconPath: 'assets/icon/performa.png'
    },
    {
      title: 'Drafts',
      url: '/members/tabs/drafts',
      icon: 'quote',
      iconPath: 'assets/icon/draft.png'
    },
    {
      title: 'Users',
      url: '/members/tabs/users',
      icon: 'people'
      ,
      iconPath: 'assets/icon/users.png'
    },
   
    {
      title: 'Products',
      url: '/members/tabs/products',
      icon: 'appstore',
      iconPath: 'assets/icon/Products.png'
    },
    {
      title: 'Company',
      url: '/members/tabs/company',
      icon: 'company',
      iconPath: 'assets/icon/company.png'
    },
    {
      title: 'Reports',
      url: '/members/tabs/reports',
      icon: 'checkmark',
      iconPath: 'assets/icon/diagram.png'
    }
    // {
    //   title: 'About',
    //   url: '/members/about',
    //   icon: 'list'
    // }
  ];
  user: any;
  type="";
  deviceId: string;
  userName: any;
  types = [{
    type: 1, name: 'Admin'
  }, {
    type: 2, name: 'Distributor'
  }, {
    type: 3, name: 'Dealer'
  }, {
    type: 4, name: 'Sales Head'
  }, {
    type: 5, name: 'Sales Rep'
  }

  ];
  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private navCtrl: NavController,
    private fcm: FCM,
    private myEvents: Events,
    private apiService: RestCallsService,
  ) {
    this.initializeApp();

  }

  removeNotification(userId) {
    this.fcm.getToken().then(token => {
      this.apiService.removeDeviceNotification({
        appName: 'ERP',
        userId: userId,
        deviceId: token
      }).subscribe((res) => {
        //console.log(res);

      });
    });
  }

  logout() {
    this.auth.getLoggedInUser().then((user: any) => {
      const userId = user.data.userId;
      this.removeNotification(userId);
      this.auth.logout();
      this.router.navigateByUrl('/login', { replaceUrl: true });

    });
  }
  initializeApp() {
    // this .platform.ready().then(() => {
    //   this .statusBar.styleDefault();
    //   this .splashScreen.hide();

    // });
    // this.platform.ready().then(() => {
    //   alert('Success'); // THIS RUNS

    //   this.splashScreen.hide();
    // });
    this .auth.getLoggedInUser().then((res: any) => {
      this .apiService.getUniqueProducts({
        orgId: res.data.orgId
      });
    });
    this.myEvents.subscribe('login', (_data:any) => {
      console.log('login',_data);
      this.changeMenu(_data.page);
      setTimeout(() => {
        this.auth.getLoggedInUser().then((user: any) => {
          console.log(user);
          this.type = this.types[user.data.type-1].name;
          if (user !== null) {
            if (user.data !== null) {
              this. appPages = [
                {
                  title: 'Dashboard',
                  url: '/members/tabs/dashboard',
                  icon: 'home',
                  iconPath: 'assets/icon/dashboard.png'
                },
                {
                  title: 'Customers',
                  url: '/members/tabs/customers',
                  icon: 'contacts'
                  ,
                  iconPath: 'assets/icon/customer.png'
                },
                {
                  title: 'Quotations',
                  url: '/members/tabs/quotations',
                  icon: 'quote',
                  iconPath: 'assets/icon/qutation.png'
                },
                {
                  title: 'Performa Invoice',
                  url: '/members/tabs/performaInvoice',
                  icon: 'checkmark',
                  iconPath: 'assets/icon/performa.png'
                },
                {
                  title: 'Drafts',
                  url: '/members/tabs/drafts',
                  icon: 'quote',
                  iconPath: 'assets/icon/draft.png'
                },
                {
                  title: 'Users',
                  url: '/members/tabs/users',
                  icon: 'people'
                  ,
                  iconPath: 'assets/icon/users.png'
                },
               
                {
                  title: 'Products',
                  url: '/members/tabs/products',
                  icon: 'appstore',
                  iconPath: 'assets/icon/Products.png'
                },
                {
                  title: 'Company',
                  url: '/members/tabs/company',
                  icon: 'company',
                  iconPath: 'assets/icon/company.png'
                },
                {
                  title: 'Reports',
                  url: '/members/tabs/reports',
                  icon: 'checkmark',
                  iconPath: 'assets/icon/diagram.png'
                }
                // {
                //   title: 'About',
                //   url: '/members/about',
                //   icon: 'list'
                // }
              ];
              this.userName = user.data.name;
              if (user.data.type != 1)
                for (let i = 0; i < this.appPages.length; i++) {
                  if ((user.data.add_user == 0 && this.appPages[i].title == "Users") ) {
                    this.appPages.splice(i, 1);
                  }
                }
              // if (user.data.type !== 1) {
              //   this .appPages.splice(4, 1);
              // }
            }
          }
        });
      }, 500);
    });
    this.fcm.onNotification().subscribe(data => {
      //console.log(data);
      if (data.wasTapped) {
        //console.log('Received in background');
      } else {
        //console.log('Received in foreground');
      }
    });
  }
  changeMenu(page: any) {
    // throw new Error('Method not implemented.');
    for(let i = 0 ; i < this. appPages.length; i++){
      if(this.appPages[i].title == page){
        this.activeIndex = i;
        break;
      }
    }
  }
  navigateToPage(url) {
    this.navCtrl.navigateForward(url, { replaceUrl: true });
  }
}
